import { getEltCoverageLabel } from 'legacy/lut/components/widgets/public/partner360/ELT'
import { useState } from 'react'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'

import { IFinancialCockpitEltDocument } from '../../../../api/types'
import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitIconButton } from '../../../components/cockpitIconButton'
import { CockpitSectionHeader } from '../../../components/cockpitSectionHeader'
import { useCockpitEltCreationPeriod } from '../../hooks/useCockpitEltCreationPeriod'

import { EltCreateDialog } from './EltCreateDialog'

interface IEltCreateControlsProps {
  iconOnly?: boolean
  isCreating?: boolean
  onCreatingChange?: (isCreating: boolean) => void
  partnerId: string
  documents: IFinancialCockpitEltDocument[]
}

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks

export const EltCreateControls = ({
  partnerId,
  documents,
  iconOnly = false,
  isCreating = false,
  onCreatingChange,
}: IEltCreateControlsProps) => {
  const t = useSafetyTranslation()
  const { fYear, fQuarter } = useCockpitEltCreationPeriod()
  const [showDialog, setShowDialog] = useState(false)
  const versionSerialNumber = Math.max(0, ...documents.map((document) => document.Version)) + 1

  return (
    <>
      {iconOnly ? (
        <CockpitIconButton
          icon="kbase kbase-add"
          label={t(KEYS.quickActions.createElt)}
          disabled={!fYear || !fQuarter || isCreating}
          onClick={() => setShowDialog(true)}
        />
      ) : (
        <CockpitSectionHeader
          actions={
            <Button size="sm" variant="outlined" onClick={() => setShowDialog(true)}>
              <Translation span text={KEYS.createRow.createButton} />
            </Button>
          }
        >
          <Translation span text={KEYS.sectionElt} /> — {getEltCoverageLabel(fYear, fQuarter)}
        </CockpitSectionHeader>
      )}

      {showDialog && fYear && fQuarter && (
        <EltCreateDialog
          show={showDialog}
          onCreatingChange={onCreatingChange}
          partnerId={partnerId}
          fYear={fYear}
          fQuarter={fQuarter}
          versionSerialNumber={versionSerialNumber}
          closeDialog={() => setShowDialog(false)}
        />
      )}
    </>
  )
}

EltCreateControls.displayName = 'EltCreateControls'
